import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";
import { FaHeadset } from "react-icons/fa";
import { LuLanguages } from "react-icons/lu";
import { Link } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  // Check if already authenticated, redirect to home
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("isAuthenticated");
    if (isAuthenticated) {
      navigate("/"); // If already authenticated, navigate to the home page
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("handleSubmit called");
    console.log("Email:", email);
    console.log("Password:", password);
    console.log("Remember Me:", rememberMe);

    try {
      // Resolve API base with sensible fallbacks (must restart dev server after changing .env)
      const API_BASE =
        process.env.REACT_APP_API_BASE ||
        process.env.REACT_APP_API_BASE_URL ||
        process.env.REACT_APP_API_BASE_URL ||
        window.REACT_APP_API_BASE ||
        window.location.origin;
      console.debug("Login: using API_BASE =", API_BASE);

      const response = await fetch(
        `${API_BASE.replace(/\/$/, "")}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      // network-level failure will throw before here; handle non-OK responses
      const dataText = await response.text().catch(() => null);
      let data = null;
      try {
        data = dataText ? JSON.parse(dataText) : null;
      } catch (e) {
        data = dataText;
      }

      console.log("Raw response data:", dataText);

      console.debug("Login response status:", response.status, "body:", data);

      if (response.ok) {
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("role", data.user.role);
        console.log("Login successful role info:" , data.user.role);
        navigate("/");
      } else {
        console.error("Login failed:", response.status, data);
        alert(
          (data && (data.message || data.error)) || "Invalid email or password"
        );
      }
    } catch (error) {
      // This is where "Failed to fetch" shows up
      console.error("Error during login (network/CORS?):", error);
      alert(
        "Network or server error. Check console and that the API server is running and CORS is enabled."
      );
    }
  };

  return (
    <div className="login-page">
      <nav className="navbar">
        <div className="navbar-logo">OANDA</div>
        <div className="navbar-icons">
          <FaHeadset className="icon" />
          <LuLanguages className="icon" />
        </div>
      </nav>
      <div className="login-container">
        <form onSubmit={handleSubmit} autoComplete="off">
          <img src="/logo/OANDA.jpg" alt="OANDA Logo" className="logo" />
          <h6>Login Your Account</h6>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="random_email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="new-email"
              className="custom-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              type="password"
              id="password"
              name="random_password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              className="custom-input"
            />
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
            />
            <label htmlFor="rememberMe">Remember me</label>
          </div>

          <button type="submit" className="btn">
            SIGN IN
          </button>

          <p className="or-divider">OR</p>

          <button type="button" className="google-btn">
            <img src="/icons/R.png" alt="Google Icon" className="google-icon" />
            SIGN IN WITH GOOGLE
          </button>

          <p className="signup-text">
            Don't have an account?{" "}
            <Link to="/signup">
              <span>Sign Up</span>
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default Login;
